import { IAlertConfig } from '../../../models/bootstrap/Alert'
import { BusinessArea } from '../../../services/AuthService'
import { ITepImportModalController } from './iTepImportModalController'
import _ from 'lodash-es';

interface WorkQueueParams {
    page: number;
    pageSize: number;
    orderBy: string;
    descending: boolean;
}

export class ITepImports {

    editFrom;

    alerts: IAlertConfig[] = []
    $dirty: boolean;

    public imports: any[];
    params: WorkQueueParams;
    loading: boolean = false;

    selections: any[];
    selectedGridItems: any[];

    allSelected: boolean;

    orderBy = 'importDate'
    orderByReversed = true;

    static $inject = ['$scope', 'Auth', '$q', '$state', '$uibModal', 'dialogs', 'iTepImports'];
    constructor(private $scope, Auth, private $q, private $state, private $uibModal, private dialogs, private iTepImports) {

        this.selections = [];
        this.selectedGridItems = [];

        this.params = {
            page: 0,
            pageSize: 50,
            orderBy: 'id',
            descending: true
        };

        $scope.$watch(() => this.selectedGridItems, (values) => {
            if (values.length > 0 && values[0]) {
                this.show(values[0]);
                this.selectedGridItems = [];
            }
        }, true);

        this.refresh();
    }

    toggleAllSelected() {
        this.allSelected = !this.allSelected;
        this.allSelectedChange();
    }

    allSelectedChange() {

        this.selections = [];
        if (this.allSelected) {
            for (let entry of this.imports) {
                entry.checked = true;
                this.selections.push(entry);
            }
        } else {
            for (let entry of this.imports) {
                entry.checked = false;
            }
        }
    }

    toggleItem(item) {
        item.checked = !item.checked;
        this.itemChanged(item);
    }

    itemChanged(item) {
        if (item.checked) {
            let serach = {
                id: item.id
            };
            if (!_.includes(this.selections, serach)) {
                this.selections.push(item);

                for (let entry of this.imports) {
                    if (!entry.checked) {
                        return
                    }
                }
                this.allSelected = true;
            }
        } else {
            this.allSelected = false;
            _.remove(this.selections, (value) => value.id === item.id);
        }
    }

    refresh() {
        this.loading = true;

        new this.iTepImports.query(this.params, (result) => {
            this.imports = result;

            this.selections = [];

            this.loading = false;
            this.$scope.$broadcast("grid_refresh");
        }, () => {
            this.loading = false;
        });
    }

    importTests() {
        this.$uibModal.open({
            templateUrl: 'areas/tools/iTep/iTepImportModal.html',
            controller: ITepImportModalController,
            controllerAs: '$ctrl',
            backdrop: false,
            resolve: {
                importfile: { importType: 'Purchases' }
            }
        }).result.then(() => {
            this.refresh();
        });
    }

    importResults() {
        this.$uibModal.open({
            templateUrl: 'areas/tools/iTep/iTepImportModal.html',
            controller: ITepImportModalController,
            controllerAs: '$ctrl',
            backdrop: false,
            resolve: {
                importfile: { importType: 'Results' }
            }
        }).result.then(() => {
            this.refresh();
        });
    }

    show(importfile) {
        this.$state.go('^.iTepImportsDetails', { id: importfile.id });
    }

    public closeAlert(index: number) {
        this.alerts.splice(index, 1)
    }
}